import React from 'react';
import { Text } from 'react-native';

//= ========================================================================

const SubTitle = ({
  children, marginBottom = 12, marginTop = 0, isBold,
}) => (
  <Text style={children ? {
    marginBottom,
    marginTop,
    fontSize: 18,
    fontFamily: isBold ? 'Quicksand-Bold' : 'Quicksand-SemiBold',
  } : {}}
  >
    {children}
  </Text>
);
export default SubTitle;
